import type { ThemeTemplate } from "../types";
import { THEME_MOTHERS_DAY } from "./mothers_day";
import { THEME_TRAVEL } from "./travel";

// English comment: Theme library (split per file for easy manual expansion).
export const THEME_TEMPLATES: ThemeTemplate[] = [
  THEME_MOTHERS_DAY,
  THEME_TRAVEL
];
